import { render } from "./ReviewSignature.vue?vue&type=template&id=38a3ccd0&scoped=true"
import script from "./ReviewSignature.vue?vue&type=script&lang=js"
export * from "./ReviewSignature.vue?vue&type=script&lang=js"

import "./ReviewSignature.vue?vue&type=style&index=0&id=38a3ccd0&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3ccd0"]])

export default __exports__